const AUTH_TOKEN_COOKIE_NAME = "dot-love-api-token_admin";

export function useAuth() {
	const token = useCookie(AUTH_TOKEN_COOKIE_NAME, {
		maxAge: 60 * 60 * 24 * 7, // 7 days
		secure: process.env.NODE_ENV === "production",
		sameSite: "lax",
	});

	const isAuthenticated = computed(() => !!token.value);

	function getToken(): string | null {
		return token.value || null;
	}

	function setToken(newToken: string): void {
		token.value = newToken;
	}

	function clearToken(): void {
		token.value = null;
	}

	async function onLogin(jwt: string): Promise<void> {
		setToken(jwt);
		// Wait for useCookie's internal watcher to flush the new value
		// to document.cookie before making the request.
		await nextTick();
		await $fetch("/auth/refresh-cookie", {
			method: "POST",
		});
	}

	async function onLogout(): Promise<void> {
		clearToken();
	}

	return {
		token: readonly(token),
		isAuthenticated,
		getToken,
		setToken,
		clearToken,
		onLogin,
		onLogout,
	};
}
